import { useTranslation } from 'react-i18next';

import type { VisibilityPrefs } from '@/entities/board/visibility';
import styles from './VisibilityToggles.module.css';

interface Props {
  value: VisibilityPrefs;
  onChange: (patch: Partial<VisibilityPrefs>) => void;
  /** Switches that make no sense for this view. */
  hide?: readonly (keyof VisibilityPrefs)[];
}

const FIELDS = [
  ['showTasks', 'filters.showTasks'],
  ['showEvents', 'filters.showEvents'],
  ['showCompleted', 'filters.showCompleted'],
  ['showOverdue', 'filters.showOverdue'],
] as const;

/** The four primary visibility switches shared by Calendar and Timeline. */
export function VisibilityToggles({ value, onChange, hide = [] }: Props) {
  const { t } = useTranslation();
  return (
    <fieldset className={styles.group}>
      <legend className="visually-hidden">{t('filters.show')}</legend>
      {FIELDS.filter(([key]) => !hide.includes(key)).map(([key, label]) => (
        <label key={key} className={styles.toggle}>
          <input
            type="checkbox"
            checked={value[key]}
            onChange={(event) => {
              onChange({ [key]: event.target.checked });
            }}
          />
          {t(label)}
        </label>
      ))}
    </fieldset>
  );
}
